<template>
  <div class="preBooking">
    <div class="row">
      <div class="col-xs-12">
        <TimeSlots></TimeSlots>
      </div>
    </div>
    <div class="text-xs-center" v-if="typeof selectedDay === 'undefined'">
      {{t('Please select a day')}}
    </div>
    <div class="text-xs-center" v-if="typeof selectedDay !== 'undefined' && availableTimes.length === 0">
      {{t('There are no more bookings available for this day')}}
    </div>
    <div v-if="typeof selectedTimeIndex !== 'undefined'">
      <div class="row">
        <div class="adults persons col-xs-8">
          <button class="btn btn-sm removeAdult" @click="removeAdult()" v-bind:class="{'btn-disabled': (adults == 0), 'btn-primary': (adults != 0)}"><i class="fa fa-minus" aria-hidden="true"></i></button>
          <span class="personType" v-if="activity.youth_age > 0"> {{adults}} <span v-if="adults !== 1">{{t('adults')}}</span><span v-else>{{t('adult')}}</span></span>
          <span class="personType" v-if="activity.youth_age == 0"> {{adults}} <span v-if="adults !== 1">{{t('participants')}}</span><span v-else>{{t('participant')}}</span></span>
          <button class="btn btn-sm addAdult" v-bind:class="{'btn-disabled': isGroupMax,'btn-primary': !isGroupMax}" @click="addAdult()"><i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>
        <div class="col-xs-4 priceAdults text-xs-right" v-if="!activity.is_priced_per_occurrence">
          <span>{{priceAdults}}</span>€
        </div>
      </div>
      <div class="row" v-if="activity.youth_age > 0">
        <div class="col-xs-8">
          <div class="children persons m-t-1">
            <button class="btn btn-sm removeChild" @click="removeChild()" v-bind:class="{'btn-disabled': (children == 0), 'btn-primary': (children != 0)}"><i class="fa fa-minus" aria-hidden="true"></i></button>
            <span class="personType"> {{children}} <span v-if="children !== 1">{{t('children')}}</span><span v-else>{{t('child')}}</span></span>
            <button class="btn btn-sm addChild" v-bind:class="{'btn-disabled': isGroupMax,'btn-primary': !isGroupMax}" @click="addChild()"><i class="fa fa-plus" aria-hidden="true"></i></button>
          </div>
        </div>
        <div class="col-xs-4 m-t-1 priceChildren text-xs-right" v-if="!activity.is_priced_per_occurrence">
          <span>{{priceChildren}}</span>€
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div v-if="activity.youth_age > 0">
            <div class="childAges" v-if="this.children">{{t('Crianças entre os')}} <b>{{activity.minimum_age}}</b> {{t('and')}} <b>{{activity.youth_age}}</b> {{t('years old')}}</div>
          </div>
        </div>
      </div>
      <div class="row" v-if="isGroupMax">
        <div class="col-sm-12"><small>{{t('The activity is available for')}} {{this.calendar.times[this.selectedTimeIndex].current_availability}} {{t('participants')}} {{t('at the selected time')}}</small></div>
      </div>
      <div class="row priceTotalContainer">
        <div class="col-xs-12 priceTotal text-xs-right">
          {{priceTotal}} € <span v-if="activity.is_priced_per_occurrence"> / {{t('group')}}</span>
        </div>
      </div>
    </div>
    <div class="bookNow text-xs-center m-t-1">
      <router-link v-if="calendar.times[selectedTimeIndex] && isAnyone" :to="`/${language}/book/${this.activity.slug}?oc=${calendar.times[selectedTimeIndex].id}&adults=${adults}&children=${children}`" class="btn btn-primary bookNowBtn">{{t('Book now')}}</router-link>
      <button v-else class="btn btn-primary" disabled>{{t('Book now')}}</button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import TimeSlots from './TimeSlots';

  export default {
    name: 'PreBooking',
    components: {
      TimeSlots,
    },
    data() {
      return {
      };
    },
    computed: {
      ...mapState({
        language: state => state.language,
        activity: state => state.activityPublic.activity,
        calendar: state => state.publicCalendar,
        selectedTimeIndex: state => state.publicCalendar.selectedTimeIndex,
        selectedDay: state => state.publicCalendar.selectedDay,
        availableTimes: state => state.publicCalendar.times,
        adults: state => state.bookingPublic.adults,
        children: state => state.bookingPublic.children,
      }),
      priceAdults() {
        return parseInt(this.adults, 10) *
        parseFloat(this.calendar.times[this.selectedTimeIndex].price);
      },
      priceChildren() {
        let youthPrice = this.calendar.times[this.selectedTimeIndex].youth_price;
        if (youthPrice === null) {
          youthPrice = this.calendar.times[this.selectedTimeIndex].price;
        }
        return parseInt(this.children, 10) * parseFloat(youthPrice);
      },
      priceTotal() {
        if (this.activity.is_priced_per_occurrence) {
          return this.calendar.times[this.selectedTimeIndex].price;
        }
        return this.priceAdults + this.priceChildren;
      },
      isGroupMax() {
        if (this.children + this.adults >=
          this.calendar.times[this.selectedTimeIndex].current_availability) {
          return true;
        }
        return false;
        // return this.children + this.adults === this.activity.group_max;
      },
      isAnyone() {
        if (this.children !== 0 || this.adults !== 0) return true;
        return false;
      },
    },
    methods: {
      ...mapActions({
        setBookingActivity: 'bookingPublic/setBookingActivity',
      }),
      addChild() {
        const persons = this.adults + this.children;
        if (persons < this.calendar.times[this.selectedTimeIndex].current_availability) {
          this.$store.dispatch('bookingPublic/setChildren', this.children + 1);
        }
      },
      removeChild() {
        if (this.children > 0) this.$store.dispatch('bookingPublic/setChildren', this.children - 1);
      },
      addAdult() {
        const persons = this.adults + this.children;
        if (persons < this.calendar.times[this.selectedTimeIndex].current_availability) {
          this.$store.dispatch('bookingPublic/setAdults', this.adults + 1);
        }
      },
      removeAdult() {
        if (this.adults > 0) this.$store.dispatch('bookingPublic/setAdults', this.adults - 1);
      },
    },
  };
</script>

<style lang="scss" scope>
@import "../../assets/scss/variables-b4"; /* for $brand-primary */
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";
/* 1.  ALL SCREENS*/
.personType {
  display: inline-block;
}
.childAges {
  font-size: 14px;
}

.priceChildren, .priceAdults {
  color: #aaa;
  padding-right: 10%;
}
.priceChildren, .priceAdults, .priceTotal {
  line-height: 40px;
}

.priceTotal {
  border-top: 1px solid #aaa;
  font-weight: 400;
  padding-right: 12px;
}
.priceTotalContainer {
  padding-top: 15px;
  margin: 0;
}

.persons {
  white-space: nowrap;
}

/* Small Screen 544px */
@media only screen and (min-width: map-get($grid-breakpoints, sm)) {

}

/* Small Devices, Tablets 768px */
@media only screen and (min-width: map-get($grid-breakpoints, md)) {
}

    /* Medium Devices, Desktops */
    @media only screen and (min-width: map-get($grid-breakpoints, lg)) {
      .personType {
        min-width: 5em;
        text-align: center;
      }
    }

    /* Large Devices, Wide Screens  1200px */
    @media only screen and (min-width: map-get($grid-breakpoints, xl)) {
      .persons .btn {
        min-width: 32px;
      }
    }

  </style>



// WEBPACK FOOTER //
// PreBooking.vue?69404166